(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("timelineitem", [], factory);
	else if(typeof exports === 'object')
		exports["timelineitem"] = factory();
	else
		root["timelineitem"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 